<div class="form-control input">
  <label class="has-float-label date-input-text placeholder-date" id="lblDateInput">
    <input type="text" name="input-msq" id="txtDateInput"
           maxlength="10"
           placeholder="dd/mm/aaaa" value=""
           class="text-input inline text-09-d-demibold txtDate"
           date-mask max-age="100" min-age="0" [(ngModel)]="DOB" (ngModelChange)="submitAnswer($event)" />
  </label>
  <p id="error-date1" class="hidden error error-txt">Para continuar, introduce una fecha válida</p>
</div>
